import "./css/index.scss"

import $ from "jquery"

import { setupContactForm } from "./js/contact-form.js"

import lightbox from "./js/lightbox.js"
import { setupMenu } from "./js/menu.js"
import { setupActivePage } from "./js/setup-active-page.js"
import { setupLightbox } from "./js/setup-lightbox.js"

import { setupTooltips } from "./js/setup-tooltips.js"
import { setupScrollTo } from "./js/scroll-to.js"
import { setupCookiePolicy } from "./js/cookies.js"

// lightbox plugin
export const lightboxE = lightbox

function onScroll() {
  // console.log(window.pageYOffset)
  const el = $(".go-top")
  const visible = "go-top--visible"
  if (window.pageYOffset > 400) {
    el.addClass(visible)
  } else {
    el.removeClass(visible)
  }
  const top = $(".top")
  if (window.pageYOffset > 50) {
    top.addClass("top--scrolled")
  } else {
    top.removeClass("top--scrolled")
  }
}

function skipToContent() {
  if (window.innerWidth < 768) {
    // const $container = $('body')
    const $scrollTo = $('[name="main-content"]')
    if ($scrollTo.length) {
      // console.log($scrollTo.offset().top)
      // const top =
      //   $scrollTo.offset().top -
      //   $container.offset().top +
      //   $container.scrollTop()
      const top = $scrollTo.offset().top
      // console.log(top)
      // $container.scrollTop(top)
      // console.log(window.pageYOffset)
      window.scrollTo(0, top)
    }
  }
}

$(function() {
  setupActivePage()

  // cookies
  setupCookiePolicy()

  // contact form
  setupContactForm()

  // scroll to
  setupScrollTo()
  // main menu
  setupMenu()
  // tooltips
  setupTooltips()
  // lightbox
  setupLightbox()

  // // owl
  // setupCarousel('.slider', {
  //   responsive: {
  //     0: {
  //       items: 1
  //     }
  //   }
  // })
  // setupCarousel('.gallery-slider__slider', optionsWithNav)
  // setupCarousel('.files__slider', optionsWithNav)
  // setupCarousel('.gallery-list__slider', optionsWithNav)
  // go-top
  window.addEventListener("scroll", onScroll)
  onScroll()
  $(".go-top").on("click", function(e) {
    e.preventDefault()
    window.scrollTo(0, 0)
  })
  // przeskocz odrazu do treści jesli jest on mobile w<768
  setTimeout(function() {
    skipToContent()
  }, 200)
})
